import React from 'react';
import { ReactComponent as TickSvg } from '../../../../assets/icons/tick.svg';
import './SettingsCheckbox.css';

interface SettingsCheckboxProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}

const SettingsCheckbox: React.FC<SettingsCheckboxProps> = ({
  checked,
  onChange,
  disabled = false,
}) => (
  <label className="settings-checkbox" onClick={(e) => e.stopPropagation()}>
    <input
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange?.(e.target.checked)}
    />
    <div className="settings-checkbox-box">
      <TickSvg className="settings-checkbox-tick" />
    </div>
  </label>
);

export default SettingsCheckbox;
